module.exports = __webpack_public_path__ + "img/fondo.bf498223.jpg";